import React from "react";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="bg-plum-900 px-4 py-14 text-white sm:py-20" data-id="element-302" data-mp="3mgae0g1vxanq">
      <div className="mx-auto max-w-5xl" data-id="element-303" data-mp="3meza8g8fw2wm">
        <div className="flex items-center justify-center gap-1" aria-label="5 out of 5 stars" data-id="element-304" data-mp="3r8kcikh2fj1m">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-6 w-6 fill-sun text-sun" aria-hidden="true" data-id="element-305" data-mp="3k884732prw" data-mpi={i} />)}
        </div>
        <h2 className="mt-3 text-center font-display text-[28px] font-extrabold leading-tight sm:text-4xl" data-id="element-306" data-mp="91w5uq6dantu">
          What Pediatric Professionals Are Saying
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-lg text-plum-100" data-id="element-307" data-mp="dywffb2fe8pp">
          Therapists and feeding specialists already using the Blueprint in their daily workflow.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-308" data-mp="2fslz64euuaul">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-5 text-slate-800" data-id="element-309" data-mp="1smm3hmsrk52c">
              <div className="flex items-center gap-3" data-id="element-310" data-mp="1nrq1puxq63c1">
                <img src={t.image} alt={t.name} className="h-16 w-16 rounded-full object-cover ring-4 ring-mint-100" loading="lazy" data-id="element-311" data-mp="1ivrewbs1otdq" />
                <div data-id="element-312" data-mp="1er1k6q94hkue">
                  <p className="flex items-center gap-1 font-display font-extrabold text-plum-950" data-id="element-313" data-mp="2bjeu1bajqrsz">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-mint-600" aria-label="Verified buyer" data-id="element-314" data-mp="26k2b31msq4vo" />
                  </p>
                  <p className="text-xs font-semibold text-slate-500" data-id="element-315" data-mp="22he3sydqd60t">{t.role}</p>
                </div>
              </div>
              <div className="mt-3 flex gap-0.5" aria-hidden="true" data-id="element-316" data-mp="1xlqbwb7v5yrm">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" data-id="element-317" data-mp="m4qitddozfwj" data-mpi={i} />)}
              </div>
              <blockquote className="mt-2 flex-1 text-[15px] leading-relaxed" data-id="element-318" data-mp="nl4ag4u06l00">“{t.quote}”</blockquote>
              <figcaption className="mt-4 text-xs font-bold text-mint-700" data-id="element-319" data-mp="skz4uiczlspt">Verified buyer</figcaption>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-320" data-mp="en0rngaek2bw">
          <CtaButton label="I Want These Results Too — $27" data-id="element-321" data-mp="im9m6nd9o48i" />
        </div>
      </div>
    </section>;
}